<template>

	<div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Existing Data Objects</h4>
			</div>
			<div class="card-body">

				Here is a full list of data objects. The next release will have a full object search and browser:
				
				<hr>
				<button class="btn btn-secondary" :disabled="!showPrevButton" @click="browseFirstPage"><i class="fas fa-angle-double-left"></i></button> <button class="btn btn-secondary" :disabled="!showPrevButton" @click="browsePrevPage"><i class="fas fa-angle-left"></i> Previous</button> Page: {{options.pagenum}} of {{listingLastPage}} <button class="btn btn-secondary" :disabled="!showNextButton" @click="browseNextPage">Next <i class="fas fa-angle-right"></i></button> <button class="btn btn-secondary" :disabled="!showNextButton" @click="browseLastPage"><i class="fas fa-angle-double-right"></i></button>
				<ul class="list-unstyled mt-3 mb-3">
					<li v-for="( o, index ) in objectList" :key="index">
						<router-link :to="'/nodes/'+ nodeId +'/projects/'+ projectId +'/collections/'+ collectionName +'/objects/'+ o.$id">{{o.title||o.name||o.$schema}} ({{o.$id}})</router-link>
					</li>
				</ul>

				<div class="form-check mb-4" v-if="!isStorageCollection( )">
					<input type="checkbox" v-model="unaugmented" class="form-check-input" id="display_augmented" checked>
					<label class="form-check-label" for="display_augmented">Bypass Augmentation <small class="text-muted">(view raw source objects <u>without</u> augmentations applied)</small></label>
				</div>

				<button class="btn btn-primary" @click.prevent="loadObjects( true )"><i class="fas fa-sync-alt"></i> Refresh</button>

			</div>
		</div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Create New Data Object</h4>
			</div>
			<div class="card-body px-3">
				
				<object-editor-item-root :key="objectEditorData._htmlId" :schemas="schemas" :item="objectEditorData" :creation="true" :allowed-schemas="allowedSchemas"></object-editor-item-root>

				<hr>
				<div class="form-group mb-0 mt-2">
					<button class="btn btn-success" @click.prevent="createObjectFromEditor"><i class="fas fa-star"></i> Create Object</button>
					<div class="form-check-inline mt-2 ml-2">
						<input type="checkbox" v-model="doNotNavigateToNewObject" class="form-check-input mt-0" id="f_doNotNavigateToNewObject">
						<label class="form-check-label" for="f_doNotNavigateToNewObject">Stay on this page after creation <small class="text-muted">(otherwise, navigates to new object)</small></label>
					</div>
				</div>

				<!-- <div class="form-group mb-0 mt-0">
					<button class="btn btn-secondary mt-2" @click.prevent="_showEditorData">Show Editor Data</button>
					<button class="btn btn-secondary mt-2" @click.prevent="_showObjectUpdates">Show Object Updates</button>
				</div> -->
				
			</div>
			
		</div>
		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Create New Data Object (JSON)</h4>
			</div>
			<div class="card-body">
				<div id="editor"></div>
				
				<div class="form-group mb-0 mt-2">
					<button class="btn btn-success" @click.prevent="createObjectFromJSON"><i class="fas fa-star"></i> Create Object from JSON</button>
					<div class="form-check-inline mt-2 ml-2">
						<input type="checkbox" v-model="doNotNavigateToNewObject" class="form-check-input mt-0" id="f_doNotNavigateToNewObject">
						<label class="form-check-label" for="f_doNotNavigateToNewObject">Stay on this page after creation <small class="text-muted">(otherwise, navigates to new object)</small></label>
					</div>
				</div>
			</div>
		</div>

	</div>
	
</template>

<script>
import 'ace-builds';
import 'ace-builds/webpack-resolver';
import _ from 'lodash';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import mixinObjectEditing from "@/components/mixins/objectEditing.js";
import ObjectEditorItem from "@/components/utilities/ObjectEditorItem";
import ObjectEditorId from "@/components/utilities/ObjectEditorId";
import ObjectEditorSchema from "@/components/utilities/ObjectEditorSchema";
import ObjectEditorItemRoot from "@/components/utilities/ObjectEditorItemRoot";
import WNValidator from '@/temp-validation/WNValidator';

export default {
	name: "data-objects",
	props: [ 'nodeId', 'projectId', 'collectionName' ],
	mixins: [
		mixinObjectEditing
	],
	components: {
		ObjectEditorItem,
		ObjectEditorId,
		ObjectEditorSchema,
		ObjectEditorItemRoot,
	},
	data() {
		return {
			options: {
				pagesize : 20,
				pagenum : 1,
				query : { },
				projection : {
					title : true,
					name : true
				},
				sort : [
					{ '$created' : -1 }
				]
			},
			objectsTotal: 0,
			unaugmented: false,
			doNotNavigateToNewObject: false,
			objectList : [],
			newObjectData: { },
			objectEditorData: {
				type : "object",
				$schema : { type : "none" },
				$id : { type : "auto" },
				fields : [
					{ fieldname : "title", type : "string.short", value : "" },
					{ fieldname : "description", type : "string.block", value : "" }
				]
			},
			schemas: {
				raw : [ ],
				compiled : { }
			},
		};
	},
	watch:
	{
		objectEditorData:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				this.updateObjectDataFromEditor( );
				this.editor.setValue( JSON.stringify( this.newObjectData, null, 2 ), -1 );
			},
		},
		unaugmented: function( newValue, oldValue )
		{
			if( newValue != oldValue )
				this.loadObjects( true );
		}
	},
	computed:
	{
		listingLastPage( )
		{
			if( !Number.isFinite( this.objectsTotal ) )
				return 0;
			return Math.ceil( this.objectsTotal / this.options.pagesize );
		},
		showNextButton( )
		{
			return this.options.pagenum < this.listingLastPage && Array.isArray( this.objectList ) && this.objectList.length > 0;
		},
		showPrevButton( )
		{
			return this.options.pagenum > 1 && Array.isArray( this.objectList );
		},
		// ...mapGetters( "objects", {
		// 	objects: "objects", // map STATE objects/objects to "objects" AS A FUNCTION, which requires the nodeId and projectId as inputs!
		// }),
		...mapGetters( "collections", {
			collection: "collection", // map STATE collections/collections to "collections" AS A FUNCTION, which requires the nodeId, projectId and collectionName as inputs!
		}),
		allowedSchemas( )
		{
			try {
				if( this.myCollection.schemas && typeof this.myCollection.schemas === 'object' )
				{
					const schemas = [];
					for( let name in this.myCollection.schemas )
						if( this.myCollection.schemas[name].allow )
							schemas.push( name );
					return schemas;
				}
			} catch( err ) { }
			return;
		},
		myCollection( )
		{
			return this.collection( this.nodeId, this.projectId, this.collectionName );
		},
	},
	methods: {
		browseFirstPage( )
		{
			this.options.pagenum = 1;
			this.loadObjects( );
		},
		browsePrevPage( )
		{
			if( this.options.pagenum > 1 )
			{
				this.$set( this.options, 'pagenum', this.options.pagenum - 1 );
				this.loadObjects( );
			}
		},
		browseNextPage( )
		{
			this.$set( this.options, 'pagenum', this.options.pagenum + 1 );
			this.loadObjects( );
		},
		browseLastPage( )
		{
			if( Number.isFinite( this.listingLastPage ) )
			{
				this.options.pagenum = this.listingLastPage;
				this.loadObjects( );
			}
		},
		schemaName( id )
		{
			return id.substring( id.indexOf( ':' ) + 1 );
		},
		_showEditorData( )
		{
			console.log( JSON.stringify( this.objectEditorData, null, 2 ) );
		},
		_showObjectUpdates( )
		{
			console.log( JSON.stringify( this.objectUpdates, null, 2 ) );
		},
		isStorageCollection( )
		{
			if( !this.myCollection )
			{
				console.warn( `My Collection [${this.collectionName}] Not Found!` );
				return true;
			}
			else
				return this.myCollection.$schema.indexOf('.reference.') < 0;
		},
		updateObjectDataFromEditor: function( )
		{
			this.newObjectData = this.editorDataToObject( this.objectEditorData );
		},
		...mapActions({
			listSchemas: "schemas/list",
			readSchema: "schemas/read",
			listObjects: "objects/list",
			createObject: "objects/create",
		}),
		async checkMySession( )
		{
			try {
				let sessionGuid = this.$store.getters['authentication/activeSession']( this.nodeId );
				return await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } );
			} catch( err ) { console.error( err ); return null; }
		},
		// getObjects( )
		// {
		// 	return this.objects( this.nodeId, this.projectId, this.collectionName );
		// },
		async loadObjects( nocache )
		{
			try {
				const options = _.defaults( { unaugmented : ( this.unaugmented ? true : undefined ) }, this.options );
				this.objectList = await this.listObjects( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, options, nocache : nocache } );
				if( typeof options.results_total === 'number' && options.results_total >= 0 )
					this.objectsTotal = options.results_total;
				//this.objectList = this.getObjects( );
			} catch( err ) {
				if( err.response && ( err.response.status === 401 ) )
				{
					console.warn( "Session expired, invalid or missing.." );
					this.checkMySession( );
				}
				else
					throw err;
			}
		},
		async createObjectFromEditor( )
		{
			this.newObjectData = this.editorDataToObject( this.objectEditorData );
			this.createNewObject( this.newObjectData );
		},
		async createObjectFromJSON( )
		{
			// TODO: Set loading overlay
			let object;

			try {
				object = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Object format issue:\n"+ err.message );
				console.error( err );
				return;
			}
			this.createNewObject( object );
		},
		async createNewObject( object )
		{
			try {
				let options = { unaugmented : ( this.unaugmented ? true : undefined ) };
				let result = await this.createObject( { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, newObject : object, options } );
				if( !result.$id )
					throw new Error( "Result from object creation came back without an ID!" );
				// this.objectList = this.getObjects( );
				this.objectList = await this.loadObjects( );
				let objectId = result.$id;
				if( !this.doNotNavigateToNewObject )
					this.$router.push( { name : 'object', params : { nodeId : this.nodeId, projectId : this.projectId, collectionName : this.collectionName, objectId } } );
				else
					alert( "Object Created Successfully!\nID: "+ objectId );
				// TODO: close loading overlay
			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.
				console.warn( "Object creation failed:", err );
				alert( "Object creation failed!\n"+ err.message );
				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
			}
		},
	},
	async created( )
	{
		const isStorage = this.isStorageCollection( );

		this.unaugmented = isStorage;

		this.loadObjects( true );	// Reload objects in the background to make sure we have the latest.

		this.$set( this.schemas, 'raw', await this.listSchemas( { nodeId : this.nodeId, projectId : this.projectId, nocache : !isStorage, options : { contextcollection : this.collectionName } } ) );
		const validator = new WNValidator( { schemas: this.schemas.raw } );

		const compiledSchemas = validator.getCompiledSchemas( { lookup: true } );
		for( let name in compiledSchemas )
		{
			const schema = compiledSchemas[name];
			schema.fieldsLookup = { };
			for( const field of schema.compiledfields )
				schema.fieldsLookup[field.name] = field;
		}
		this.$set( this.schemas, 'compiled', compiledSchemas );

		console.warn( "FINISHED SCHEMA RETRIEVAL!" );

		this.updateObjectDataFromEditor( );
		this.editor.setValue( JSON.stringify( this.newObjectData, null, 2 ), -1 );
	},
	async mounted( )
	{
		this.editor = ace.edit( "editor", {
			mode: "ace/mode/json",
			theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
			maxLines: 20,
			minLines: 5,
			fontSize: 14,
			showPrintMargin : false
		});
	}
};
</script>

<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/DataObjects.vue